import { Component, OnInit } from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {CurrentRouteService} from "../../currentRoute.service";
import {AccountIdService, AccountNameService, AgencyIdService} from "../../account.service";
import {IntegrationProviderService} from "../integration-provider.service";
import {DomSanitizer} from "@angular/platform-browser";
import {GoogleadsPostInterfaceData} from "../integrations-googleads/integrations-googleads.component";
import * as _ from "lodash";

export interface  FacebookPostInterfaceData {
  serviceName: string
}

@Component({
  selector: 'app-integration-facebook',
  templateUrl: './integration-facebook.component.html',
  styleUrls: ['./integration-facebook.component.css']
})
export class IntegrationFacebookComponent implements OnInit {

  helps = []

  is_loading = false;
  checked = false;
  color: ThemePalette = 'primary';
  is_refresh_token = false;
  agency_id:string;
  account_id:string;
  //url: string = "https://graph.facebook.com/oauth/authorize?client_id=513447909791730&redirect_uri=https://devwebhook.angleattribution.com/webhooks/facebook/add&scope=ads_management,ads_read,read_insights,public_profile&state=whdbf5982c3f8740c7a9db34578c2e43c6"
  url: string;
  is_redirect_url = false;
  webhook_id: string;
  data = {}

  constructor(public router: Router,
              public route: ActivatedRoute,
              public dialog: MatDialog,
              private currentrouteService: CurrentRouteService,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private accountnameService: AccountNameService,
              private _integrationProviderService: IntegrationProviderService,
              private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.currentrouteService.announceCurrentRoute(this.router.url);

    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id'],
        this.account_id = parms['account_id'],
        this.agencyidService.announceAgencyId(this.agency_id);
      this.accountidService.announceAccountId(this.account_id);
      this.load_data()
    });
  }

  load_data(){

    this.is_redirect_url = false;
    this.webhook_id = null;
    this.checked = false;

    this.is_loading = true
    let endpoint = `webhooks/account/${this.account_id}`;

    let fu = this._integrationProviderService.get(endpoint).subscribe(x => {
      //console.log('!!!!!!!!!!!!',_.isEmpty(x['body']))


      if (_.isEmpty(x['body'])){
        //this.is_data = true
      } else {
        for (const [cn, v] of Object.entries(x['body'])) {
          //console.log(cn, v);
          if (v['serviceName'] == 'facebook'){
            this.webhook_id = v['webhook_id']
            this.data = v;
          }
          //this.global_object[cn] = v
          //this.adwords_accounts.push(cn);
          //this.adwords_accounts_object[cn] = v;
        }
        //this.campaign_name_list = this.global_object['campaign_name_list']
      }

      if ('redirect_url' in this.data){
        this.is_redirect_url = true;
      }

      if ('is_connected' in this.data){
          if (this.data['is_connected']=="true"){
            this.checked = true;
          } else{
            this.checked = false;
          }
      }
      if ('access_token' in this.data){
        this.is_refresh_token = true;
      }
      if ('redirect_url' in this.data){
        this.url = this.data['redirect_url']
      }

      this.is_loading = false;


    },error => {
      console.log('ERROR ',error)
      this.is_loading = false;
    }); //end apiService

  } //end load_data

  goBack() {
    window.history.back();
  } // end of goBack

  pop:any;
  onPop(){
    this.pop = window.open(this.url,'popup','width=600,height=600');
  }

  onDelete(){

    let endpoint = `webhooks/${this.webhook_id}`;
    let fu = this._integrationProviderService.delete(endpoint).subscribe(x => {
      console.log(x);
      this.is_redirect_url = false;
      this.webhook_id = null;
      this.checked = false;
      this.load_data();
    }, error => {
      console.log('ERROR ', error)
      this.is_loading = false;
    }); //end _integrationProviderService.delete

  } //end onDelete


  onPopClose(){
    this.pop.close();
  }

  submit(){

    let endpoint = `webhooks/account/${this.account_id}`
    console.log(endpoint)
    let data:FacebookPostInterfaceData = {serviceName: 'facebook'}
    this._integrationProviderService.post_googleads(endpoint, data).subscribe(x => {
      console.log(x)
      this.url = x['body']['redirect_url']
      this.onPop()
      //this.load_data()
    }); //end post

  }

}
